import React, {Component} from "react";
import PropTypes from "prop-types";
import { Image } from "react-konva";
import { connect } from "react-redux";
import { ImagenSonda } from "./ImageContext";
import { mueveTransductor } from "../js/actions/index";
import caso from "../caso";

const mapStateToProps = state => {
	return { 
		anatomia: state.anatomia,
		abordajeActual:state.exploracion.abordajeActual,
		casoActual:state.exploracion.casoActual, 
	};
};

function mapDispatchToProps(dispatch) {
	return {
		mueveRaton: (dir) => dispatch(mueveTransductor(dir))
	};
}
class TransductorConected extends Component{
	static contextType = ImagenSonda;
	static propTypes = {
		anatomia : PropTypes.object,
		casoActual: PropTypes.number,
		abordajeActual: PropTypes.number,
		mueveRaton: PropTypes.func,
	}
	mouseDownTransductor = (e)=>{
		this.coords = {
			x: e.evt.pageX,
			y: e.evt.pageY
		};
		document.addEventListener("mousemove", this.handleMouseMove);
		document.addEventListener("mouseup", this.handleMouseUp);
		if(e.preventDefault)
			e.preventDefault();
		else if(e.evt && e.evt.preventDefault)
			e.evt.preventDefault();
	}
	
	handleMouseMove = (e)=>{
		let xDiff = e.pageX - this.coords.x;
		let yDiff = e.pageY - this.coords.y;
		this.coords.x = e.pageX;
		this.coords.y = e.pageY;
		this.props.mueveRaton({x:xDiff,y:yDiff});
		if(e.preventDefault)
			e.preventDefault();
		else if(e.evt && e.evt.preventDefault)
			e.evt.preventDefault();
	}
	
	handleMouseUp = () => {
		document.removeEventListener("mousemove", this.handleMouseMove);
		document.removeEventListener("mouseup", this.handleMouseUp);
		this.coords = {};
	};
	
	render(){
		if(this.props.casoActual >= 0 && this.props.abordajeActual >= 0){
			let abordaje = caso[this.props.casoActual].abordajes[this.props.abordajeActual];
			let offsetX = 368;
			let offsetY = 70;
			abordaje.recorrido.forEach((recorrido) =>{
				if(recorrido.tipo === "giro" && recorrido.mod === "lat")
					offsetY = 10;
				if(recorrido.tipo === "giro" && (recorrido.mod === "lat inv" || recorrido.mod === "lat1"))
					offsetY = 137;
			});
			const trans = this.props.anatomia.trans;
			let datosTransductor = {
				scaleX:(this.props.anatomia.size.width/700)*abordaje.escala,
				scaleY:(this.props.anatomia.size.width/700)*abordaje.escala,
				x : trans.x * this.props.anatomia.size.width,
				y : trans.y * this.props.anatomia.size.height,
				image : this.context[trans.basc + 90],
				offsetX: offsetX,
				offsetY: offsetY,
				rotation: trans.rot*180/Math.PI,
			};
			const imagen = <Image {...datosTransductor} onMouseDown={this.mouseDownTransductor}/>;
			return imagen;
		}else return null;
	}
}

export default connect(mapStateToProps,mapDispatchToProps) (TransductorConected);